import { Link } from 'react-router-dom';
import { Download } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { IconTile } from '@/components/IconTile';
import { cn } from '@/lib/utils';

interface ResourceListItemProps {
  icon: React.ReactNode;
  title: string;
  meta?: string;
  badge?: string;
  href?: string;
  onAction?: () => void;
  showDownload?: boolean;
  className?: string;
}

export function ResourceListItem({
  icon,
  title,
  meta,
  badge,
  href,
  onAction,
  showDownload = false,
  className,
}: ResourceListItemProps) {
  const content = (
    <>
      <IconTile icon={icon} size="md" />
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className="truncate font-medium text-ink-900 dark:text-white">{title}</span>
          {badge && <Badge variant="neutral" className="text-[0.65rem]">{badge}</Badge>}
        </div>
        {meta && <div className="mt-0.5 text-xs text-ink-500 dark:text-muted-foreground">{meta}</div>}
      </div>
      {(showDownload || onAction) && !href && (
        <Download className="h-4 w-4 shrink-0 text-ink-400 transition group-hover:text-brand-500 dark:group-hover:text-primary" />
      )}
    </>
  );

  const cls = cn(
    'group flex w-full items-center gap-4 py-3 text-left transition hover:text-brand-600 dark:hover:text-primary',
    className,
  );

  if (href) {
    return (
      <li>
        <Link to={href} className={cls}>{content}</Link>
      </li>
    );
  }

  return (
    <li>
      <button type="button" onClick={onAction} className={cls}>{content}</button>
    </li>
  );
}
